// Registered details for AV Facade Services Ltd, shared by all three legal documents
// and the Contact page. The address block appears six times across the Privacy Policy,
// Cookie Policy and Terms of Service — keeping one copy here means a change of address
// is a single edit.
const addressLines = ["6 Cape Valentine Way", "Newport", "NP20 2SP", "United Kingdom"];

export const legalContact = {
  name: "AV Facade Services Ltd",
  lines: addressLines,
  // Same address on one line, for the Contact page's info card. Drops the country,
  // which the legal documents need but a UK-facing contact card does not.
  addressInline: addressLines.slice(0, 3).join(", "),
  email: "aurimas@avfacades.co.uk",
  phone: "+44 7757 669706",
  // Digits only, for the tel: href — matching the icoContact convention below.
  phoneHref: "tel:+447757669706",
};

// UK supervisory authority, referenced by the complaints sections of the Privacy and
// Cookie policies.
export const icoContact = {
  name: "Information Commissioner's Office (ICO)",
  website: "https://ico.org.uk",
  telephone: "0303 123 1113",
  // Digits only, for the tel: href.
  telephoneHref: "tel:+443031231113",
};

export default legalContact;
